// extracted by mini-css-extract-plugin
export default {"headerContent":"PageWrapperHeader_headerContent__nYAsS","headerLogo":"PageWrapperHeader_headerLogo__gScMa","pageTitle":"PageWrapperHeader_pageTitle__Dr7dr"};